import React, { createContext, useContext } from "react";
import useSessionStorage from "../hooks/useSessionStorage";

const UserContext = createContext(null);

const useUser = () => {
    return useContext(UserContext);
};

const UserContextProvider = ({ children }) => {
    const [user, setUser] = useSessionStorage("user", null);
    return (
        <UserContext.Provider value={[user, setUser]}>
            {children}
        </UserContext.Provider>
    );
};

export default UserContextProvider;
export { UserContext, useUser };
